export default __webpack_public_path__ + "static/media/news5.929c47a6.jpg";